module.exports = __webpack_public_path__ + "static/media/marcus.1c000f71.jpeg";